import { defineMessages } from 'react-intl';

export const estimationDetailEstimationItemOmitModalMessageDefinitions = defineMessages({
  title: {
    id: 'estimationDetail.estimationItemOmitModal.title',
    defaultMessage: 'Provide Reason',
  },
  reasonPlaceholder: {
    id: 'estimationDetail.estimationItemOmitModal.reason.placeholder',
    defaultMessage: 'Meaningful short description for management (max 210 characters)',
  },
  confirmButton: {
    id: 'estimationDetail.estimationItemOmitModal.confirmButton',
    defaultMessage: 'Confirm Removing',
  },
});
